module.exports = __webpack_public_path__ + "static/img/b_3_cross.c50eae96.png";